import { Area } from "@ant-design/plots";
import { Row } from "antd";
import { Loader } from "../../Loader";
import { useSingleLineChartConfig } from "../../../hooks/useSingleLineChartConfig";

type ChartProps = {
  data: any;
  isLoading: boolean;
};

export const Chart = ({ data, isLoading }: ChartProps) => {
  const { config } = useSingleLineChartConfig(data);

  return (
    <Row className="mt-4 w-100">
      {!isLoading ? (
        <>
          {data.length > 0 ? (
            <Area {...config} />
          ) : (
            <Row className="w-100 mt-10 pt-10 justify-center">
              <p className="my-0 text title">No Data</p>
            </Row>
          )}
        </>
      ) : (
        <Row className="w-100 mt-10 pt-10 justify-center">
          <Loader />
        </Row>
      )}
    </Row>
  );
};
